import { AvailableLanguages } from '@repo/toolkit/language-types'
import { SVGFC } from '@repo/toolkit/types'
import { EnglishIcon, GermanIcon, SpainIcon } from '@repo/ui/icons'

import { t } from '../../../../locale/utils'
import { CountryKey } from '../../models/country/country-list'

export enum LanguageEnum {
  ENGLISH = 'ENGLISH',
  GERMAN = 'GERMAN',
  SPANISH = 'SPANISH'
}

export const languageEnumMapping = (
  language?: AvailableLanguages
): Record<LanguageEnum, { label: string; icon: SVGFC; countryCode: CountryKey }> => ({
  [LanguageEnum.ENGLISH]: {
    label: t('language.enum.english', { language }),
    icon: EnglishIcon,
    countryCode: CountryKey.GBR
  },
  [LanguageEnum.GERMAN]: {
    label: t('language.enum.german', { language }),
    icon: GermanIcon,
    countryCode: CountryKey.DEU
  },
  [LanguageEnum.SPANISH]: {
    label: t('language.enum.spanish', { language }),
    icon: SpainIcon,
    countryCode: CountryKey.ESP
  }
})
